module.exports = __webpack_public_path__ + "img/presenter_shirabe.b8857fe7.jpg";